import React, { useEffect } from 'react';
import { HeaderStepper } from '../Common/HeaderStepper/HeaderStepper';
import { Container, Row } from "react-bootstrap";
import { glEmbeddedApplicationSetup } from './gl.js';

export default function GerberForm(props) {
  const frameName = "embeddedIframe";
  const hostUrl = "https://testing1.glic.io";
  const params = {
    cssFile: "https://nbstagingapplicationdata.blob.core.windows.net:443/public/test.css",
    "value(State)": "ID",
    "aKeycode": "00020000",
    "userId": "00020001"
  }
  const appUrl = "/gl/ng/entry/agencyEmbedded/guarlife";
  //"/gl/ng/entry/agencyEmbedded/growup"

  // eslint-disable-next-line
  var glEmbeddedApp = null;
  useEffect(() => {
    glEmbeddedApp = glEmbeddedApplicationSetup(frameName, hostUrl, params, appUrl)
      .onAppEvent('pageChanged', function (event) {
        // handle page changed event 
        console.log(event.pageName);
      }).onAppEvent('applicationSubmitted', function (event) {
        // handle application submission event 
        console.log(event.applicationId);
      }).success(function (data) {
        // application submitted successfully 
        console.log(data.applicationId);
      }).error(function (error) {
        // application error occured 
      })
  });

  return (
    <HeaderStepper title="Guaranteed Life Insurance" hideProgressTracker whiteBg>
      <Container className="gerber-form">
        <Row>
          <iframe name="embeddedIframe" width="100%" height="0" scrolling="no" frameBorder="no" title="gerber"/>
        </Row>
      </Container >
    </HeaderStepper>
  )

}



// WEBPACK FOOTER //
// ./src/components/Quoters/Forms/GerberForm.js